/**
 * Format name with proper capitalization
 * - First letter uppercase
 * - Rest lowercase
 * - Handles O'g'li, O'rinboy, etc.
 */
export const formatName = (name) => {
  if (!name || name.toLowerCase() === 'xxx' || name.toLowerCase() === 'x') {
    return '';
  }

  // Split by spaces and hyphens
  const words = name.replace(/-/g, ' - ').split(' ');
  const fixedWords = [];

  for (const word of words) {
    if (word === '-') {
      fixedWords.push('-');
      continue;
    }

    // Handle words with apostrophes like O'g'li, O'rinboy
    if (word.includes("'") || word.includes("'") || word.includes("'")) {
      // Normalize apostrophes
      const normalized = word.replace(/['']/g, "'");
      const parts = normalized.split("'");
      const fixedParts = parts.map((part, i) => {
        if (!part) return '';
        // First letter uppercase, rest lowercase
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
      });
      fixedWords.push(fixedParts.join("'"));
    } else {
      // Regular word - first letter uppercase, rest lowercase
      fixedWords.push(word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
    }
  }

  return fixedWords.join(' ').replace(/ - /g, '-');
};

/**
 * Format full name (last name, first name, middle name)
 * Filters out empty/xxx values
 */
export const formatFullName = (firstName, lastName, middleName) => {
  const parts = [
    formatName(lastName),
    formatName(firstName),
    formatName(middleName)
  ].filter(part => part); // Remove empty strings

  return parts.join(' ');
};

/**
 * Format a complete name string (handles full names like "Axrorov Faxriddin O'rinboy O'g'li")
 * Splits by spaces and formats each part
 */
export const formatCompleteName = (fullName) => {
  if (!fullName) return '';
  
  // Split by spaces
  const parts = fullName.split(' ').map(part => formatName(part)).filter(part => part);
  
  return parts.join(' ');
};

/**
 * Format display name (first name + last name for Avatar)
 * Returns '**' if both are missing
 */
export const formatDisplayName = (firstName, lastName) => {
  const first = formatName(firstName);
  const last = formatName(lastName);
  
  if (!first && !last) return '**';
  
  return `${first} ${last}`.trim();
};
